module.exports = __webpack_public_path__ + "static/media/newmotors-alpha.77e951ec.png";